import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      {...rest}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </M>
  );
};

export const MaskLine = ({ children, delay = 0, className = "", animateOnMount = false }) => {
  const trigger = animateOnMount
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span initial="hidden" {...trigger} className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-3 text-xs font-medium tracking-[0.2em] uppercase text-muted-foreground ${className}`}>
    <span className="h-px w-8 bg-current opacity-50" />
    {children}
  </span>
);
